import { Image } from '@applane/react-core-components';
import Toast from '@applane/react-toast';
import React, { useState } from 'react';
import { invoke } from '../../AppServices';
import { squareCloseFillIcon, squareCloseIcon } from '../../images';
import { ROUTES } from '../../Lib/constants';
import { notifyAppraisal } from '../OpenRepairOrder/List';

const theme = {
  boxToHoldLabel: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 30,
  },
  labelStyle: {
    fontSize: 15,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 300,
  },

  boxToHoldInputField: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  inputFieldStyle: {
    outline: '0px',
    border: '1px solid grey',
    borderRadius: 10,
    height: 30,
    width: 300,
    paddingLeft: 6,
  },

  focusInputFieldStyle: {
    outline: '0px',
    border: '1px solid black',
    borderRadius: 10,
    height: 30,
    width: 300,
    paddingLeft: 6,
  },

  boxToHoldErrorBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  errorBox: {
    display: 'flex',
    flexDirection: 'row',
    color: 'rgba(255,0,0,0.5)',
    fontSize: 14,
    width: 300,
    fontFamily: 'Batang',
    marginTop: 5,
    paddingLeft: 5,
  },

  submitButtonProperties: {
    borderRadius: 20,
    backgroundColor: '#444',
    color: 'white',
    width: 100,
    height: 30,
  },

  hoverSubmitButtonProperties: {
    borderRadius: 20,
    backgroundColor: '#222',
    color: 'white',
    width: 100,
    height: 30,
  },
};

export const ManualAppraisalPopup = (props) => {
  const [spread, setSpread] = useState({ value: '', error: '' });
  const [enhancement, setEnhancement] = useState({ value: '', error: '' });
  const [submitButtonHover, setSubmitButtonHover] = useState(false);
  const [focus, setFocus] = useState({
    spreadFocus: false,
    enhancementFocus: false,
  });
  const [closeButtonHover, setCloseButtonHover] = useState(false);
  const { navigation, eventDispatcher } = props;
  const record = navigation?.state?.params?.data;

  console.log('navigation', navigation)

  const spreadChange = (e) => {
    if (/^(\-)?\d+\.?\d*$/.test(e.target.value)) {
      // yes entered stuff is number...
      setSpread({ value: e.target.value, error: '' });
    } else {
      // anything else but not a number so setting an error.
      if (e.target.value === '') {
        setSpread({
          value: '',
          error: 'This field must not be left empty',
        });
      } else {
        setSpread({ value: e.target.value, error: 'This must be a number' });
      }
    }
  };

  const enhancementchange = (e) => {
    if (/^(\-)?\d+\.?\d*$/.test(e.target.value)) {
      // yes entered stuff is number...
      setEnhancement({ value: e.target.value, error: '' });
    } else {
      // anything else but not a number so setting an error.
      if (e.target.value === '') {
        setEnhancement({
          value: '',
          error: 'This field must not be left empty.',
        });
      } else {
        setEnhancement({
          value: e.target.value,
          error: 'This must be a number',
        });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (spread.error === '' && enhancement.error === '') {
      eventDispatcher.notify('appLoader', true);
      const { result } = await invoke({
        id: 'manualAppraise',
        paramValue: {
          data: record,
          spread: parseInt(spread.value, 10),
          enhancement: parseInt(enhancement.value, 10),
        },
      });
      eventDispatcher.notify('appLoader', false);

      if (result && !result.error) {
        // navigation.reset(ROUTES.avFailList.name);

        navigation.reset("appraisal-result-list-avgen");

        const temp = await notifyAppraisal();

        // appraisal-result-list-avgen
        // navigation.navigate("")
        // navigation.navigate(ROUTES.viewAppraisalResult.name, {
        //   item: { _id: result._id, type: result.type },
        //   showButtonsList: true,
        //   notifyAppraisal: temp,
        // });
      }

      if (result && result.error) {
        Toast.show({
          message: 'Error',
          description: result.error,
          type: 'error',
          position: 'top',
          direction: 'right',
        });
      }
    }
  };

  const spreadInputFieldStyle = {
    outline: '0px',
    border: '1px solid grey',
    borderRadius: 10,
    height: 30,
    width: 300,
    paddingLeft: 6,
  };

  if (focus.spreadFocus) {
    spreadInputFieldStyle.border = '1px solid black';
  }
  if (spread.error !== '') {
    spreadInputFieldStyle.border = '1px solid red';
  }

  const enhancementInputFieldStyle = {
    outline: '0px',
    border: '1px solid grey',
    borderRadius: 10,
    height: 30,
    width: 300,
    paddingLeft: 6,
  };

  if (focus.enhancementFocus) {
    enhancementInputFieldStyle.border = '1px solid black';
  }
  if (enhancement.error !== '') {
    enhancementInputFieldStyle.border = '1px solid red';
  }

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        style={{
          borderRadius: 20,
          width: 400,
          height: 400,
          backgroundColor: 'white',
          marginTop:"200px"
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              width: 375,
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row-reverse',
              marginTop: 15,
            }}
          >
            <Image
              onClick={() => navigation.pop()}
              style={{ width: 20, height: 20, cursor: 'pointer' }}
              source={closeButtonHover ? squareCloseFillIcon : squareCloseIcon}
              onMouseOver={() => setCloseButtonHover(true)}
              onMouseLeave={() => setCloseButtonHover(false)}
            />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              color: 'red',
              fontSize: 22,
              marginTop: 20,
              fontFamily: 'serif',
            }}
          >
            <i>{record?.errorCause}</i>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              // border: '2px solid blue',
            }}
          >
            <div style={theme.boxToHoldLabel}>
              <label style={theme.labelStyle}>Spread %</label>
            </div>
            <div style={theme.boxToHoldInputField}>
              <input
                placeholder="Spread"
                type="text"
                value={spread.value}
                onChange={spreadChange}
                style={spreadInputFieldStyle}
                onFocus={() => {
                  setFocus({ spreadFocus: true, enhancementFocus: false });
                }}
              />
            </div>
            <div style={theme.boxToHoldErrorBox}>
              <label style={theme.errorBox}>
                <i>{spread.error}</i>
              </label>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              // border: '2px solid blue',
            }}
          >
            <div style={theme.boxToHoldLabel}>
              <label style={theme.labelStyle}>Enhancement %</label>
            </div>
            <div style={theme.boxToHoldInputField}>
              <input
                placeholder="Enhancement"
                type="text"
                value={enhancement.value}
                onChange={enhancementchange}
                style={enhancementInputFieldStyle}
                onFocus={() => {
                  setFocus({ spreadFocus: false, enhancementFocus: true });
                }}
              />
            </div>
            <div style={theme.boxToHoldErrorBox}>
              <label style={theme.errorBox}>
                <i>{enhancement.error}</i>
              </label>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 30,
              }}
            >
              <input
                type="submit"
                value="Proceed"
                style={
                  submitButtonHover
                    ? theme.hoverSubmitButtonProperties
                    : theme.submitButtonProperties
                }
                onMouseOver={() => setSubmitButtonHover(true)}
                onMouseLeave={() => setSubmitButtonHover(false)}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
